import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    setBusinessesReducer,
    addBusinessReducer,
    removeBusinessReducer,
    updateBusinessReducer,
    setCurrentBusinessReducer,
} from "../reducers";

export const fetchAllBusinesses = createAsyncThunk(
    "businesses/fetchAll",
    async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/businesses`);
        const businesses = await res.json();

        const map = {};
        businesses.forEach(b => { map[b.id] = b; });
        return map;
    },
    {
        condition: (_, { getState }) => {
            return getState().businesses.status !== "loading";
        },
    }
);

export const deleteBusinessById = createAsyncThunk(
    "businesses/deleteById",
    async (businessId) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/businesses/${businessId}`, {
            method: "DELETE",
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || "Failed to delete business");
        }
        return businessId;
    }
);

export const fetchBusinessesByVendor = createAsyncThunk(
    "businesses/fetchByVendor",
    async (vendorId) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/businesses-of-vendor/${vendorId}`);
        const businesses = await res.json();

        const list = Array.isArray(businesses) ? businesses : [];
        const map = {};
        list.forEach(b => { map[b.id] = b; });
        return { map, list };
    }
);

const initialState = {
    businesses: {},
    currentBusiness: null,
    status: "idle",
    error: null,
    vendorBusinesses: [],
    vendorBusinessesStatus: "idle",
};

const businessSlice = createSlice({
    name: "businesses",
    initialState,
    reducers: {
        setBusinesses: setBusinessesReducer,
        addBusiness: addBusinessReducer,
        removeBusiness: removeBusinessReducer,
        updateBusiness: updateBusinessReducer,
        setCurrentBusiness: setCurrentBusinessReducer,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllBusinesses.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchAllBusinesses.fulfilled, (state, action) => {
                if (action.payload !== null) {
                    state.businesses = action.payload;
                    state.status = "succeeded";
                }
            })
            .addCase(fetchAllBusinesses.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(fetchBusinessesByVendor.pending, (state) => {
                state.vendorBusinessesStatus = "loading";
            })
            .addCase(fetchBusinessesByVendor.fulfilled, (state, action) => {
                state.vendorBusinesses = action.payload.list;
                state.vendorBusinessesStatus = "succeeded";
            })
            .addCase(fetchBusinessesByVendor.rejected, (state) => {
                state.vendorBusinessesStatus = "failed";
            })
            .addCase(deleteBusinessById.fulfilled, (state, action) => {
                const id = action.payload;
                delete state.businesses[id];
                state.vendorBusinesses = state.vendorBusinesses.filter(b => b.id !== id);
            });
    },
});

export const { setBusinesses, addBusiness, removeBusiness, updateBusiness, setCurrentBusiness } = businessSlice.actions;
export default businessSlice.reducer;
